module.exports = __webpack_public_path__ + "img/placeholder-profile.15bebc06.png";